import ProjectTypeProvider  from './ProjectTypeProvider'

export default ProjectTypeProvider
